import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {SupportSlotsController} from '../../../../api/support/support-slots.controller';
import CreateSupportSlotDefinition = SupportSlotsController.CreateSupportSlotDefinition;

export type SupportSlotDefinitionCreateDrawerState = {
  slotDefinition: CreateSupportSlotDefinition
  setSlotDefinition: (data: CreateSupportSlotDefinition) => void
  translateLocal: (key: string) => string
  translate: (key: string) => string
  handleSubmit: () => Promise<void>
}

const defaultCreateSupportSlot = (weekday: number): CreateSupportSlotDefinition => ({
  weekday: weekday,
  startTime: '09:00',
  endTime: '10:00',
  isGlobal: false,
  validFrom: new Date().toISOString().split('T')[0],
  validTo: new Date(new Date().setMonth(new Date().getMonth() + 1)).toISOString().split('T')[0],
});

export const useSupportSlotDefinitionCreateDrawerState = (weekday: number): SupportSlotDefinitionCreateDrawerState => {
  const {t} = useTranslation()
  const [slotDefinition, setSlotDefinition] = useState<CreateSupportSlotDefinition>(defaultCreateSupportSlot(weekday));

  useEffect(() => {
    setSlotDefinition(defaultCreateSupportSlot(weekday));
  }, [weekday]);

  return {
    slotDefinition: slotDefinition,
    setSlotDefinition: setSlotDefinition,
    translate: key => t(key),
    translateLocal: key => t(`support-plan-page.plan-update-drawer.${key}`),
    handleSubmit: async () => {
      await SupportSlotsController.createSupportSlotDefinition(slotDefinition)
    }
  };
};